export default "Escapee opened in March 2019. \n\nNote that one of their rooms, \"Area 51\", is in Danish only.";